/*
 * Copyright 2020 Anton Trushkov
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

package org.ksdfv.thelema.input

/** @author zeganstyl */
interface IKeyListener {
    /** Called when a key was pressed
     *
     * @param keycode one of the constants in [KB]
     * @return whether the input was processed
     */
    fun keyDown(keycode: Int) = Unit

    /** Called when a key was released
     *
     * @param keycode one of the constants in [KB]
     * @return whether the input was processed
     */
    fun keyUp(keycode: Int) = Unit

    /** Called when a key was typed
     *
     * @param character The character
     * @return whether the input was processed
     */
    fun keyTyped(character: Char) = Unit
}